import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { User } from "Components/Icons";
import { ImageUpload, ImageUploadHandle } from "Components/Inputs";
import { Button } from "Components/ReactstrapSlim";
import { Module, ModuleCaption } from "Components/Module";
import { PictureClient as PictureClientNew, ImageTagConstants, PictureViewModel } from "Services/API/API";
import { useApiClient } from "Services/API/useApiClient";
import { userSelector } from "Utils/selectors";

const ProfileImage = () => {
    const user = useSelector(userSelector);
    const pictureClientNew = useApiClient(PictureClientNew);    
    const [picture, setPicture] = useState<PictureViewModel | null>(null);
    const [pictureUrl, setPictureUrl] = useState<string>("");
    const [isLoading, setIsLoading] = useState(true);
    const imageUpload = React.useRef<ImageUploadHandle>(null);
    
    const onImageChanged = () => {
        LSStore.instance.dispatch(LSStore.refreshUserThunk());
    }

    const loadPictureData = async (abortSignal: AbortSignal) => {
        try {
            const pictureViewModel = await pictureClientNew.getMemberPictureViewModel(user.id!, ImageTagConstants.UserPicture, abortSignal)
            setPicture(pictureViewModel);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }   

    useEffect(() => {
        const abortController = new AbortController();
        loadPictureData(abortController.signal);
        return() => {
            abortController.abort();
        }
    }, [])

    return(
        <Module loading={false} fluid className={classNames("module-profile-image")}>
            <ModuleCaption className="mb-px8">
                Profile Image
            </ModuleCaption>
            <div className="profile-image-wrapper">
                <div className="image-wrapper">
                    { !isLoading
                        ? pictureUrl && !pictureUrl.includes(Guid.Empty)
                            ? <img onClick={imageUpload.current?.edit} style={{cursor: "pointer"}} src={pictureUrl} alt={user.fullName || undefined} />
                            : <User size={168} />
                        : null
                    }
                </div>
                <div className="buttons-wrapper">
                    <span className={classNames("btn btn-primary", imageUpload.current?.wrapperClassName)}>
                        Upload <ImageUpload                        
                        pictureId={picture?.pictureId}
                        pictureOwnerId={user.id!}                        
                        pictureType={LSCommon.Enums.PictureTypeEnum.Member}
                        pictureTag={LSCrossTier.ImageTagConstants.UserPicture}
                        width={336}
                        height={336}
                        crop={false}                    
                        onPictureUrlChanged={setPictureUrl}
                        onImageUploaded={onImageChanged}
                        onImageRemoved={onImageChanged}
                        deleteModalTitle="Are you sure you want to delete your current profile image?"
                        editModalTitle="Edit profile image"
                        uploadModalTitle="Upload new profile image"
                        roundedBorder={true}

                        ref={imageUpload} />
                    </span>
                    <Button color="secondary" disabled={!user.imageUrl} onClick={() => imageUpload.current?.delete()} >Delete</Button>                    
                </div>
            </div>           
        </Module>
    )
}

export default ProfileImage;